import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Text, NumericalValue } from 'modules/styled/text';
import { getTopPosts } from 'modules/post/post.actions';
import { getTitle, getFavIcon, getPostUrl } from 'app/utils/post';
import { abbreviateNumber } from 'app/utils/numbers';
import { Image, View, Row, InlineLink } from 'modules/styled';

const BG_COLORS = ['black', 'white'];

class Marquee extends Component {
  static propTypes = {
    rows: PropTypes.number,
    actions: PropTypes.object,
    posts: PropTypes.object,
    communityState: PropTypes.object,
  };

  static defaultProps = {
    rows: 1,
  };

  x = [];

  rows = [];

  componentDidMount() {
    this.props.actions.getTopPosts();
    this.animate();
    window.addEventListener('blur', this.pause);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.pause);
    window.removeEventListener('focus', this.animate);
    cancelAnimationFrame(this.lastFrame);
  }

  pause = () => {
    cancelAnimationFrame(this.lastFrame);
    window.removeEventListener('focus', this.animate);
    window.addEventListener('focus', this.animate);
  };

  rowSpeed = (i) => {
    switch (i % 3) {
      case 0:
        return 0.6;
      case 1:
        return 0.85;
      case 2:
        return 0.75;
      default:
        return 0.6;
    }
  };

  animate = () => {
    const now = new Date();
    const elapsed = this.lastTime ? (now - this.lastTime) / 10 : 0;

    this.x = this.rows.map((row, i) => {
      const w = row.offsetWidth / 2;
      let newX = (this.x[i] || i) - elapsed * this.rowSpeed(i);
      if (newX <= -w) newX += w;
      const rX = Math.round(newX * 1000) / 1000;
      row.style.transform = `translate3d(${rX}px, 0, 0)`;
      return rX;
    });

    this.lastTime = now;
    this.lastFrame = requestAnimationFrame(this.animate);
  };

  renderTicker = (row, key) => {
    const { posts, rows, communityState } = this.props;
    const links = posts.topPosts.filter((post) => post.title);

    return links.map((post, i) => {
      if (i % rows !== row) return null;
      const color = BG_COLORS[(row + 1) % 2];
      const community = communityState.communities[post.data.community];
      if (!community) return null;
      const avgRank = community.currentShares / community.postCount;
      const tick = post.data.pagerank - avgRank;
      const title = getTitle({ post, maxLength: 60 })?.toUpperCase();
      if (!title) return null;
      const icon = getFavIcon(post.metaPost.domain);

      const tickerString = (
        <Fragment>
          <Image
            sx={{
              display: 'inline-block',
              bg: 'white',
              width: 3,
              height: 3,
              mr: 1,
              mb: -2.0001,
            }}
            source={icon}
            resizeMode={'contain'}
          />
          <Text sx={{ mr: 4.001, color }}>{title}</Text>
          <Text sx={{ mr: 4.001, color: tick < 0 ? 'red' : 'green' }}>
            {tick >= 0 ? '▲' : '▼'}
          </Text>
          <Text sx={{ color }}>{abbreviateNumber(tick)}%</Text>
        </Fragment>
      );

      return (
        <InlineLink
          sx={{ display: 'inline-block' }}
          key={`${post._id}${key}`}
          to={getPostUrl(post.data.community, post)}
        >
          <NumericalValue sx={{ py: 2, px: 4 }}>{tickerString}</NumericalValue>
        </InlineLink>
      );
    });
  };

  renderRow = (row) => {
    const bg = BG_COLORS[row % 2];

    const tickers = this.renderTicker(row, 1);
    const tickersDouble = this.renderTicker(row, 2);
    return (
      <View sx={{ bg, py: 4.001 }} key={`row${row}`}>
        <Text style={{ whiteSpace: 'nowrap' }} ref={(c) => (this.rows[row] = c)}>
          {tickers}
          {tickersDouble}
        </Text>
      </View>
    );
  };

  render() {
    const { rows: N } = this.props;
    const rows = Array.from(Array(N).keys());
    return (
      <Row
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          zIndex: 10,
          position: 'fixed',
          top: 0,
          left: 0,
        }}
      >
        {rows.map(this.renderRow)}
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    posts: state.posts,
    communityState: state.community,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getTopPosts,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Marquee);
